import { Box, LeaderboardPodium } from "@memorang/ui";
import type { LeaderboardItemType } from "./types";

type Props = {
	topRankers: LeaderboardItemType[];
	avatarType?: "initials" | "identicon";
};

const TopRankersList = ({ topRankers, avatarType }: Props) => {
	return (
		<Box
			flexDirection="row"
			justifyContent="center"
			alignItems="flex-end"
			width="100%"
		>
			{topRankers.map(({ username, xp, rank, avatar }) => (
				<LeaderboardPodium
					key={username}
					title={username}
					xp={xp}
					rank={rank!}
					image={avatar}
					avatarType={avatarType}
				/>
			))}
		</Box>
	);
};

export default TopRankersList;
